// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { BentukKerjasamaDetailResponse } from "./types";
import * as bentukKerjasamaActions from "./bentukKerjasama.actions";

export function* getDetailBentukKerjasama(
  action: ReturnType<typeof bentukKerjasamaActions.getDetailBentukKerjasamaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `bentuk-kerjasama/${action.payload.id}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: BentukKerjasamaDetailResponse = yield call(result.json.bind(result));
      yield put(bentukKerjasamaActions.getDetailBentukKerjasamaAsync.success(parsed.data));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(bentukKerjasamaActions.getDetailBentukKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(bentukKerjasamaActions.getDetailBentukKerjasamaAsync.failure(parsed));
  }
}

export default function* bentukKerjasamaSagaGetDetailBentukKerjasama() {
  yield takeEvery(bentukKerjasamaActions.getDetailBentukKerjasamaAsync.request, getDetailBentukKerjasama);
}
